import { mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { videoCardGroupWidgetStyles as styles } from "@iewcasia/Widgets/VerndaleBox/VideoCardGroupWidget";
import { css } from "styled-components";

styles.title = {
    variant: "h2",
};

styles.cardWrapper = {
    css: css`
        & > [class*="Wrapper-"] {
            display: flex;
            flex-wrap: wrap;

            ${mediaQueriesBP.maxMD} {
                width: 100%;

                & > * {
                    width: calc(50% - 10px);
                    flex: 0 0 calc(50% - 10px);

                    &:nth-child(2n) {
                        margin-left: 20px;
                    }

                    &:nth-child(n + 3) {
                        margin-top: 20px;
                    }
                }
            }
        }
    `,
};
